module.exports = __webpack_public_path__ + "img/rule-btn1.5fe7b435.png";